namespace GeniuzPOS.SalePromoCamp {
    export class PsPromoCampaignColumns {
        static columnsKey = 'SalePromoCamp.PsPromoCampaign';
    }
}
